// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
  /* Mobile Screen 576px */
  --mobile: 576px;
  /* Tablet Screen 768px */
  --tablet: 768px;
  /* Laptop Screen 992px */
  --laptop: 992px;
  /* Desktop Screen 1200px */
  --desktop: 1200px;
  /* Large-Desktop Screen 1600px */
  --large-desktop: 1600px;
  --cm-green-100: #bfffba;
  --mintel-green-200: #9acd32;
  --mintel-sand-50: #fffcf1;
  --cm-deep-purple-50: #f1e9ff;
  --cm-pink-400: #c31e8a;
  --mintel-gray-50: #f8f8f8;
  --cm-blue-100: #90ffff;
  --cm-green-200: #05ff7e;
  --mintel-green-300: #7fa829;
  --cm-pink-500: #830669;
  --cm-blue-200: #00e0ff;
  --cm-green-300: #00cc8f;
  --mintel-green-400: #458415;
  --mintel-mint-50: #def7e6;
  --cm-pink-600: #5c1440;
  --mintel-blue-100: #c1dcf8;
  --cm-blue-300: #008eff;
  --cm-green-400: #00857a;
  --mintel-green-500: #325d10;
  --cm-purple-100: #ffc4ff;
  --mintel-blue-200: #89c3fe;
  --cm-blue-400: #0050dc;
  --cm-green-500: #005866;
  --mintel-purple-100: #f3d9ee;
  --mintel-green-600: #273300;
  --cm-purple-200: #ff70ff;
  --mintel-blue-300: #519de9;
  --mintel-purple-200: #e1a2d5;
  --cm-purple-300: #d500f9;
  --mintel-blue-400: #026fd9;
  --cm-blue-500: #00138c;
  --cm-green-600: #002133;
  --cm-purple-400: #9100b7;
  --mintel-blue-500: #0052a5;
  --cm-blue-600: #000b54;
  --mintel-purple-300: #cf6abc;
  --cm-purple-500: #550075;
  --mintel-blue-600: #013161;
  --mintel-purple-400: #ac2f96;
  --mintel-gold-100: #ffedbf;
  --cm-purple-600: #330046;
  --mintel-purple-50: #faf0f8;
  --mintel-purple-500: #681c5a;
  --mintel-gold-200: #ffd97a;
  --cm-plum: #661d51;
  --cm-purple-50: #ffe3fc;
  --mintel-black: #000;
  --mintel-purple-600: #380e38;
  --mintel-gold-300: #ffb400;
  --mintel-yellow: #fedb00;
  --cm-lime: #defab6;
  --mintel-blue-50: #edf5fd;
  --mintel-mint-100: #beefce;
  --cm-black: #000;
  --mintel-gray-100: #e8e8e8;
  --cm-blue-50: #c8ffff;
  --mintel-mint-200: #99e6b3;
  --mintel-gold-400: #c88c00;
  --mintel-gray-200: #ccc;
  --cm-green-50: #e6ffde;
  --cm-deep-purple-100: #dccaff;
  --mintel-sand-100: #fff8dc;
  --mintel-mint-300: #7ebd93;
  --mintel-gold-500: #7d5a00;
  --mintel-green-50: #e5f2cb;
  --mintel-gray-300: #939393;
  --cm-deep-purple-200: #b871ff;
  --mintel-sand-200: #e8e2c8;
  --mintel-mint-400: #547e62;
  --mintel-red-100: #ffb9b9;
  --mintel-gray-400: #666;
  --mintel-seafoam: #11a988;
  --cm-deep-purple-300: #8e3eff;
  --mintel-mint-500: #385442;
  --mintel-red-200: #ff7474;
  --mintel-gray-500: #2b2b2b;
  --cm-seafoam: #00ffe1;
  --cm-deep-purple-400: #550fcc;
  --mintel-mint-600: #203226;
  --cm-neon-50: #faffc2;
  --mintel-red-300: #f83943;
  --cm-pink-50: #fce3ec;
  --mintel-lavender-100: #dedeea;
  --cm-deep-purple-500: #3b0b89;
  --mintel-red-400: #cb0b16;
  --mintel-lavender-200: #aeaeca;
  --cm-deep-purple-600: #350066;
  --mintel-red-500: #87080f;
  --mintel-lavender-300: #7d7eab;
  --mintel-royal: #5e358b;
  --mintel-aqua: #afe9d8;
  --mintel-red-600: #461212;
  --mintel-lavender-400: #4d4e8c;
  --mintel-white: #fff;
  --mintel-lavender-500: #353957;
  --cm-white: #fff;
  --mintel-lavender-600: #1c1d33;
  --mintel-orange-100: #ffcc98;
  --mintel-orange-50: #ffebd6;
  --mintel-orange-200: #ffa343;
  --mintel-orange-300: #e66723;
  --mintel-orange-400: #bf360c;
  --mintel-orange-500: #7a2308;
  --mintel-orange-600: #461405;
  --cm-neon-100: #f1ff82;
  --mintel-lavender-50: #eeeef4;
  --cm-pink-100: #f8bbd0;
  --cm-pink-200: #ff66ac;
  --cm-neon-200: #cf0;
  --mintel-red-50: #ffe3e3;
  --mintel-green-100: #bedf7c;
  --cm-pink-300: #ff0076;
  --cm-neon-300: #aadc00;
  /* Primary font for Mintel branding - DEPRECATED, use Neue Einstellung */
  --lato-font: NeueEinstellung, Arial;
  /* Primary font across all products */
  --neue-einstellung-font: NeueEinstellung, Arial;
  --arial-font: Arial;
  /* Data font */
  --dinpro-font: DINPro, Arial;
  --data-cell-weight: normal;
  --data-annotation-height: 12px;
  --breadcrumb-height: 16px;
  --ban2-height: 30px;
  --ban1-height: 30px;
  --body-height: 20px;
  --data-header-height: 14px;
  --button-weight: bold;
  --link-size: 11px;
  --body3-weight: normal;
  --legal-size: 10px;
  --body2-weight: normal;
  --data-pagination-weight: normal;
  --data-cell-size: 14px;
  --h6-weight: bold;
  --h5-weight: bold;
  --h4-weight: bold;
  --h3-weight: bold;
  --link-height: 16px;
  --legal-height: 16px;
  --h2-weight: bold;
  --button-size: 12px;
  --h1-weight: bold;
  --body3-size: 11px;
  --data-cell-height: 14px;
  --body2-size: 12px;
  --data-pagination-size: 12px;
  --h6-size: 12px;
  --h5-size: 14px;
  --data-annotation-weight: normal;
  --ban2-weight: normal;
  --breadcrumb-weight: normal;
  --button-height: normal;
  --h4-size: 16px;
  --data-header-weight: bold;
  --body3-height: 16px;
  --h3-size: 18px;
  --ban1-weight: normal;
  --body-weight: normal;
  --body2-height: 20px;
  --h2-size: 22px;
  --data-pagination-height: 14px;
  --h1-size: 30px;
  --h6-height: 20px;
  --h5-height: 20px;
  --h4-height: 20px;
  --h3-height: 24px;
  --data-annotation-size: 12px;
  --h2-height: 30px;
  --ban2-size: 24px;
  --h1-height: normal;;
  --link-weight: normal;
  --breadcrumb-size: 11px;
  --ban1-size: 22px;
  --body-size: 14px;
  --data-header-size: 12px;
  --legal-weight: normal;
  /* (XXS) Tiny spacing */
  --spacing-100: 2px;
  /* (XS) Extra Small spacing */
  --spacing-200: 4px;
  /* (S) Small spacing */
  --spacing-300: 8px;
  /* (S+) spacing */
  --spacing-350: 12px;
  /* (M) Medium spacing */
  --spacing-400: 16px;
  /* (M+) Medium spacing */
  --spacing-450: 24px;
  /* (L) Large spacing */
  --spacing-500: 32px;
  /* (XL) Extra large spacing */
  --spacing-600: 64px;
  --h5-size-responsive: 0.875rem;
  --h6-size-responsive: 0.75rem;
  --data-pagination-size-responsive: 0.75rem;
  --body2-size-responsive: 0.75rem;
  --data-cell-height-responsive: 0.875rem;
  --body3-size-responsive: 0.6875rem;
  --button-size-responsive: 0.75rem;
  --legal-height-responsive: 1rem;
  --link-height-responsive: 16px;
  --data-cell-size-responsive: 0.875rem;
  --legal-size-responsive: 0.625rem;
  --link-size-responsive: 0.6875rem;
  --data-header-height-responsive: 0.875rem;
  --body-height-responsive: 1.25rem;
  --ban1-height-responsive: 30px;
  --ban2-height-responsive: 1.875rem;
  --breadcrumb-height-responsive: 1rem;
  --data-annotation-height-responsive: 0.75rem;
  --body-size-responsive: 0.875rem;
  --ban1-size-responsive: 1.375rem;
  --data-header-size-responsive: 0.75rem;
  --breadcrumb-size-responsive: 0.6875rem;
  --h1-height-responsive: normal;;
  --ban2-size-responsive: 1.5rem;
  --data-annotation-size-responsive: 0.75rem;
  --h2-height-responsive: 1.875rem;
  --h3-height-responsive: 1.5rem;
  --h4-height-responsive: 1.25rem;
  --h5-height-responsive: 1.25rem;
  --h6-height-responsive: 1.25rem;
  --h1-size-responsive: 1.875rem;
  --data-pagination-height-responsive: 0.875rem;
  --body2-height-responsive: 1.25rem;
  --h2-size-responsive: 1.375rem;
  --h3-size-responsive: 1.125rem;
  --body3-height-responsive: 1rem;
  --h4-size-responsive: 1rem;
  --button-height-responsive: normal;
  /* (M+) Medium spacing */
  --spacing-450-responsive: 1.5rem;
  /* (S+) spacing */
  --spacing-350-responsive: 0.75rem;
  /* (XXL) Extra Extra large spacing */
  --spacing-700-responsive: 5rem;
  /* (XL) Extra large spacing */
  --spacing-600-responsive: 4rem;
  /* (L) Large spacing */
  --spacing-500-responsive: 2rem;
  /* (M) Medium spacing */
  --spacing-400-responsive: 1rem;
  /* (S) Small spacing */
  --spacing-300-responsive: 0.5rem;
  /* (XS) Extra Small spacing */
  --spacing-200-responsive: 0.25rem;
  /* (XXS) Tiny spacing */
  --spacing-100-responsive: 0.125rem;
}
`, "",{"version":3,"sources":["webpack://./node_modules/mintel-tokens/dist/tokens.custom-properties.css"],"names":[],"mappings":";AACA;EACE,wBAAwB;EACxB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,gCAAgC;EAChC,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;EACtB,sBAAsB;EACtB,wEAAwE;EACxE,mCAAmC;EACnC,qCAAqC;EACrC,+CAA+C;EAC/C,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,0CAA0C;EAC1C,gCAAgC;EAChC,uCAAuC;EACvC,kCAAkC;EAClC,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,qCAAqC;EACrC,iCAAiC;EACjC,iCAAiC;EACjC,yCAAyC;EACzC,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,oCAAoC;EACpC,4CAA4C;EAC5C,gCAAgC;EAChC,gCAAgC;EAChC,sCAAsC;EACtC,uCAAuC;EACvC,8BAA8B;EAC9B,8BAA8B;EAC9B,0CAA0C;EAC1C,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,6CAA6C;EAC7C,kCAAkC;EAClC,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;EAClC,wBAAwB;EACxB,gCAAgC;EAChC,iBAAiB;EACjB,iCAAiC;EACjC,oCAAoC;EACpC,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;EAChC,6BAA6B;EAC7B,iCAAiC;EACjC,uBAAuB;EACvB,kCAAkC;AACpC","sourcesContent":["\n:root {\n  /* Mobile Screen 576px */\n  --mobile: 576px;\n  /* Tablet Screen 768px */\n  --tablet: 768px;\n  /* Laptop Screen 992px */\n  --laptop: 992px;\n  /* Desktop Screen 1200px */\n  --desktop: 1200px;\n  /* Large-Desktop Screen 1600px */\n  --large-desktop: 1600px;\n  --cm-green-100: #bfffba;\n  --mintel-green-200: #9acd32;\n  --mintel-sand-50: #fffcf1;\n  --cm-deep-purple-50: #f1e9ff;\n  --cm-pink-400: #c31e8a;\n  --mintel-gray-50: #f8f8f8;\n  --cm-blue-100: #90ffff;\n  --cm-green-200: #05ff7e;\n  --mintel-green-300: #7fa829;\n  --cm-pink-500: #830669;\n  --cm-blue-200: #00e0ff;\n  --cm-green-300: #00cc8f;\n  --mintel-green-400: #458415;\n  --mintel-mint-50: #def7e6;\n  --cm-pink-600: #5c1440;\n  --mintel-blue-100: #c1dcf8;\n  --cm-blue-300: #008eff;\n  --cm-green-400: #00857a;\n  --mintel-green-500: #325d10;\n  --cm-purple-100: #ffc4ff;\n  --mintel-blue-200: #89c3fe;\n  --cm-blue-400: #0050dc;\n  --cm-green-500: #005866;\n  --mintel-purple-100: #f3d9ee;\n  --mintel-green-600: #273300;\n  --cm-purple-200: #ff70ff;\n  --mintel-blue-300: #519de9;\n  --mintel-purple-200: #e1a2d5;\n  --cm-purple-300: #d500f9;\n  --mintel-blue-400: #026fd9;\n  --cm-blue-500: #00138c;\n  --cm-green-600: #002133;\n  --cm-purple-400: #9100b7;\n  --mintel-blue-500: #0052a5;\n  --cm-blue-600: #000b54;\n  --mintel-purple-300: #cf6abc;\n  --cm-purple-500: #550075;\n  --mintel-blue-600: #013161;\n  --mintel-purple-400: #ac2f96;\n  --mintel-gold-100: #ffedbf;\n  --cm-purple-600: #330046;\n  --mintel-purple-50: #faf0f8;\n  --mintel-purple-500: #681c5a;\n  --mintel-gold-200: #ffd97a;\n  --cm-plum: #661d51;\n  --cm-purple-50: #ffe3fc;\n  --mintel-black: #000;\n  --mintel-purple-600: #380e38;\n  --mintel-gold-300: #ffb400;\n  --mintel-yellow: #fedb00;\n  --cm-lime: #defab6;\n  --mintel-blue-50: #edf5fd;\n  --mintel-mint-100: #beefce;\n  --cm-black: #000;\n  --mintel-gray-100: #e8e8e8;\n  --cm-blue-50: #c8ffff;\n  --mintel-mint-200: #99e6b3;\n  --mintel-gold-400: #c88c00;\n  --mintel-gray-200: #ccc;\n  --cm-green-50: #e6ffde;\n  --cm-deep-purple-100: #dccaff;\n  --mintel-sand-100: #fff8dc;\n  --mintel-mint-300: #7ebd93;\n  --mintel-gold-500: #7d5a00;\n  --mintel-green-50: #e5f2cb;\n  --mintel-gray-300: #939393;\n  --cm-deep-purple-200: #b871ff;\n  --mintel-sand-200: #e8e2c8;\n  --mintel-mint-400: #547e62;\n  --mintel-red-100: #ffb9b9;\n  --mintel-gray-400: #666;\n  --mintel-seafoam: #11a988;\n  --cm-deep-purple-300: #8e3eff;\n  --mintel-mint-500: #385442;\n  --mintel-red-200: #ff7474;\n  --mintel-gray-500: #2b2b2b;\n  --cm-seafoam: #00ffe1;\n  --cm-deep-purple-400: #550fcc;\n  --mintel-mint-600: #203226;\n  --cm-neon-50: #faffc2;\n  --mintel-red-300: #f83943;\n  --cm-pink-50: #fce3ec;\n  --mintel-lavender-100: #dedeea;\n  --cm-deep-purple-500: #3b0b89;\n  --mintel-red-400: #cb0b16;\n  --mintel-lavender-200: #aeaeca;\n  --cm-deep-purple-600: #350066;\n  --mintel-red-500: #87080f;\n  --mintel-lavender-300: #7d7eab;\n  --mintel-royal: #5e358b;\n  --mintel-aqua: #afe9d8;\n  --mintel-red-600: #461212;\n  --mintel-lavender-400: #4d4e8c;\n  --mintel-white: #fff;\n  --mintel-lavender-500: #353957;\n  --cm-white: #fff;\n  --mintel-lavender-600: #1c1d33;\n  --mintel-orange-100: #ffcc98;\n  --mintel-orange-50: #ffebd6;\n  --mintel-orange-200: #ffa343;\n  --mintel-orange-300: #e66723;\n  --mintel-orange-400: #bf360c;\n  --mintel-orange-500: #7a2308;\n  --mintel-orange-600: #461405;\n  --cm-neon-100: #f1ff82;\n  --mintel-lavender-50: #eeeef4;\n  --cm-pink-100: #f8bbd0;\n  --cm-pink-200: #ff66ac;\n  --cm-neon-200: #cf0;\n  --mintel-red-50: #ffe3e3;\n  --mintel-green-100: #bedf7c;\n  --cm-pink-300: #ff0076;\n  --cm-neon-300: #aadc00;\n  /* Primary font for Mintel branding - DEPRECATED, use Neue Einstellung */\n  --lato-font: NeueEinstellung, Arial;\n  /* Primary font across all products */\n  --neue-einstellung-font: NeueEinstellung, Arial;\n  --arial-font: Arial;\n  /* Data font */\n  --dinpro-font: DINPro, Arial;\n  --data-cell-weight: normal;\n  --data-annotation-height: 12px;\n  --breadcrumb-height: 16px;\n  --ban2-height: 30px;\n  --ban1-height: 30px;\n  --body-height: 20px;\n  --data-header-height: 14px;\n  --button-weight: bold;\n  --link-size: 11px;\n  --body3-weight: normal;\n  --legal-size: 10px;\n  --body2-weight: normal;\n  --data-pagination-weight: normal;\n  --data-cell-size: 14px;\n  --h6-weight: bold;\n  --h5-weight: bold;\n  --h4-weight: bold;\n  --h3-weight: bold;\n  --link-height: 16px;\n  --legal-height: 16px;\n  --h2-weight: bold;\n  --button-size: 12px;\n  --h1-weight: bold;\n  --body3-size: 11px;\n  --data-cell-height: 14px;\n  --body2-size: 12px;\n  --data-pagination-size: 12px;\n  --h6-size: 12px;\n  --h5-size: 14px;\n  --data-annotation-weight: normal;\n  --ban2-weight: normal;\n  --breadcrumb-weight: normal;\n  --button-height: normal;\n  --h4-size: 16px;\n  --data-header-weight: bold;\n  --body3-height: 16px;\n  --h3-size: 18px;\n  --ban1-weight: normal;\n  --body-weight: normal;\n  --body2-height: 20px;\n  --h2-size: 22px;\n  --data-pagination-height: 14px;\n  --h1-size: 30px;\n  --h6-height: 20px;\n  --h5-height: 20px;\n  --h4-height: 20px;\n  --h3-height: 24px;\n  --data-annotation-size: 12px;\n  --h2-height: 30px;\n  --ban2-size: 24px;\n  --h1-height: normal;;\n  --link-weight: normal;\n  --breadcrumb-size: 11px;\n  --ban1-size: 22px;\n  --body-size: 14px;\n  --data-header-size: 12px;\n  --legal-weight: normal;\n  /* (XXS) Tiny spacing */\n  --spacing-100: 2px;\n  /* (XS) Extra Small spacing */\n  --spacing-200: 4px;\n  /* (S) Small spacing */\n  --spacing-300: 8px;\n  /* (S+) spacing */\n  --spacing-350: 12px;\n  /* (M) Medium spacing */\n  --spacing-400: 16px;\n  /* (M+) Medium spacing */\n  --spacing-450: 24px;\n  /* (L) Large spacing */\n  --spacing-500: 32px;\n  /* (XL) Extra large spacing */\n  --spacing-600: 64px;\n  --h5-size-responsive: 0.875rem;\n  --h6-size-responsive: 0.75rem;\n  --data-pagination-size-responsive: 0.75rem;\n  --body2-size-responsive: 0.75rem;\n  --data-cell-height-responsive: 0.875rem;\n  --body3-size-responsive: 0.6875rem;\n  --button-size-responsive: 0.75rem;\n  --legal-height-responsive: 1rem;\n  --link-height-responsive: 16px;\n  --data-cell-size-responsive: 0.875rem;\n  --legal-size-responsive: 0.625rem;\n  --link-size-responsive: 0.6875rem;\n  --data-header-height-responsive: 0.875rem;\n  --body-height-responsive: 1.25rem;\n  --ban1-height-responsive: 30px;\n  --ban2-height-responsive: 1.875rem;\n  --breadcrumb-height-responsive: 1rem;\n  --data-annotation-height-responsive: 0.75rem;\n  --body-size-responsive: 0.875rem;\n  --ban1-size-responsive: 1.375rem;\n  --data-header-size-responsive: 0.75rem;\n  --breadcrumb-size-responsive: 0.6875rem;\n  --h1-height-responsive: normal;;\n  --ban2-size-responsive: 1.5rem;\n  --data-annotation-size-responsive: 0.75rem;\n  --h2-height-responsive: 1.875rem;\n  --h3-height-responsive: 1.5rem;\n  --h4-height-responsive: 1.25rem;\n  --h5-height-responsive: 1.25rem;\n  --h6-height-responsive: 1.25rem;\n  --h1-size-responsive: 1.875rem;\n  --data-pagination-height-responsive: 0.875rem;\n  --body2-height-responsive: 1.25rem;\n  --h2-size-responsive: 1.375rem;\n  --h3-size-responsive: 1.125rem;\n  --body3-height-responsive: 1rem;\n  --h4-size-responsive: 1rem;\n  --button-height-responsive: normal;\n  /* (M+) Medium spacing */\n  --spacing-450-responsive: 1.5rem;\n  /* (S+) spacing */\n  --spacing-350-responsive: 0.75rem;\n  /* (XXL) Extra Extra large spacing */\n  --spacing-700-responsive: 5rem;\n  /* (XL) Extra large spacing */\n  --spacing-600-responsive: 4rem;\n  /* (L) Large spacing */\n  --spacing-500-responsive: 2rem;\n  /* (M) Medium spacing */\n  --spacing-400-responsive: 1rem;\n  /* (S) Small spacing */\n  --spacing-300-responsive: 0.5rem;\n  /* (XS) Extra Small spacing */\n  --spacing-200-responsive: 0.25rem;\n  /* (XXS) Tiny spacing */\n  --spacing-100-responsive: 0.125rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
